
import { Era } from "@/types/investigator";
import { getEraConfig } from "@/config/era-registry";

type TableType = 'occupations' | 'skills' | 'weapons';

/**
 * Resolve the database/JSON table name for a given era and data type.
 * Replaces scattered ternary chains throughout the codebase.
 */
export function getEraTable(era: Era | string, type: TableType): string {
  const config = getEraConfig(era);
  return config.tables[type];
}
